import { Attributes, Model, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";
import { LookupFields } from "../InvestorInvestment";
import IssuerInvestmentLookup from "../../IssuerInvestments/Lookups/IssuerInvestmentLookup";
import Entity from "../../Catalogue/Investments/Entity";
import InvestorLookup from "../../Investors/Lookups/InvestorLookup";
import ProductType from "../../Catalogue/General/ProductType";

@NeoModel
export default class NewInvestorInvestmentCommand extends ModelBase {

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    public investorId: number | null = null;

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    public investmentId: number | null = null;

    @Attributes.Nullable()
    public productTypeId: number | null = null;

    public lookup = new LookupFields();

    // Client only properties / methods

    @Attributes.NoTracking()
    public isInvestorRestricted = false;

    @Attributes.NoTracking()
    public isIssuerRestricted = false;

    @Attributes.NoTracking()
    private isIssuerProductTypeRestricted = false;

    @Attributes.NoTracking()
    public productTypeIdParentFilter: number | null = null;

    public setInvestor(investor:  Model.PlainObject<InvestorLookup> | undefined) {
        this.investorId = investor?.investorId ?? null;
        this.lookup.investorName = investor?.investorName ?? null;
        this.isInvestorRestricted = investor?.isRestricted ?? false;
    }

    public setEntity(entity: Entity | undefined) {
        this.lookup.setEntity(entity);
        this.setInvestment(undefined);
    }

    public setProductType(productType: ProductType | undefined) {
        this.productTypeId = productType?.productTypeId ?? null;
        if (productType?.filterParentInvestment) {
            this.productTypeIdParentFilter = productType.productTypeId;
        } else {
            this.productTypeIdParentFilter = null;
        }
    }

    public setInvestment(investment: Model.PlainObject<IssuerInvestmentLookup> | undefined) {
        this.investmentId = investment?.investmentId ?? null;
        this.isIssuerRestricted = investment?.isIssuerRestricted ?? false;
        this.isIssuerProductTypeRestricted = investment?.productTypeFilterParent ?? false;
    }

    protected addBusinessRules(context: Validation.Rules<NewInvestorInvestmentCommand>) {

        context.failWhen(c => !c.issuerInvestmentId && c.lookup.hasVestingTrust, "Issuer investment is required.");
        context.failWhen(c => c.isInvestorRestricted, "Investor is restricted from trading.").onProperties(c => c.investorId);
        context.failWhen(c => c.isIssuerRestricted, "Issuer is restricted from trading.").onProperties(c => c.issuerInvestmentId);
        context.failWhen(c => c.productTypeIdParentFilter === null && c.isIssuerProductTypeRestricted, 
            "Cannot choose this issuer investment because it has a restricted product type.").onProperties(c => c.issuerInvestmentId);
    }
}